// Which saved views a person is offered (R-U2, audit 28.10 P1-18): shared ones and their own personal ones, and only those whose
// filter they can evaluate — a view filtered by a link to a section they do not read would always be empty for them.

import { canRead, type Access, type Filter, type MetaIndex, type ViewDef } from '@confdeck/core-shared';

function readable(meta: MetaIndex, access: Access, typeId: string, f: Filter | null | undefined): boolean {
  if (!f) return true;
  if ('and' in f) return f.and.every((x) => readable(meta, access, typeId, x));
  if ('or' in f) return f.or.every((x) => readable(meta, access, typeId, x));
  if ('not' in f) return readable(meta, access, typeId, f.not);
  const field = meta.field(typeId, f.field);
  if (field?.fieldType !== 'relation') return true;
  const target = meta.relationTarget(field)?.typeId;
  return !!target && canRead(access, target) && readable(meta, access, target, (f as { where?: Filter }).where);
}

export function offeredViews(meta: MetaIndex, access: Access, me: string | null | undefined, typeId: string): ViewDef[] {
  return meta.views(typeId).filter((v) => (v.shared || v.ownerId === me) && (access.all || readable(meta, access, typeId, v.filter)));
}
